import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conditionalTitleCase'
})
export class ConditionalTitleCasePipe implements PipeTransform {

   transform(value: string): string {
    if (!value) return '';
    
    const isAllCaps = value === value.toUpperCase();
    
    return isAllCaps ? value : this.toTitleCase(value);
  }

  private toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
 

}
